import { render, staticRenderFns } from "./EditTransportRoute.vue?vue&type=template&id=42d4880a&scoped=true&"
import script from "./EditTransportRoute.vue?vue&type=script&lang=js&"
export * from "./EditTransportRoute.vue?vue&type=script&lang=js&"
import style0 from "./EditTransportRoute.vue?vue&type=style&index=0&id=42d4880a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d4880a",
  null
  
)

export default component.exports